import createSagaMiddleware, { SagaMiddleware } from "redux-saga";
import { configureStore, Store, Middleware } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";

import { authReducer, AuthStore } from "./auth/auth.store";
import { messageReducer, MessagesStore } from "./messages/messages.store";
import { chatReducer, ChatStore } from "./chat/chat.store";
import { activePhonesReducer, ActivePhonesStore } from "./active-phones/active-phones.store";
import { chatFoldersReducer, ChatFoldersStore } from "./chat/folders/folders.store";
import { modalsReducer, ModalsStore } from "./modals/modals.store";
import { ArchiveReducer, ArchiveStore } from "./chat/archive/archive.store";
import { SearchReducers, SearchStore } from "./chat/search/search.store";
import { callsReducer, CallsStore } from "./calls/calls.store";
import { Views, ViewsReducer } from "./views/views.store";

import { errorReducer, ErrorStore } from "~/app/error/error.store";
import rootSaga from "~/app/saga";

export interface ApplicationStore {
  error: ErrorStore;
  auth: AuthStore;
  message: MessagesStore;
  callsStore: CallsStore;
  chats: ChatStore;
  activePhones: ActivePhonesStore;
  chatFolders: ChatFoldersStore;
  modals: ModalsStore;
  archive: ArchiveStore;
  views: Views;
  search: SearchStore;
}

const sentryReduxEnhancer: any = Sentry.createReduxEnhancer({
  // Optionally pass options listed below
});

export function createApplicationStore(): Store<ApplicationStore> {
  const sagaMiddleware: SagaMiddleware = createSagaMiddleware();
  const store: Store<ApplicationStore> = configureStore({
    reducer: {
      error: errorReducer,
      auth: authReducer,
      message: messageReducer,
      callsStore: callsReducer,
      chats: chatReducer,
      activePhones: activePhonesReducer,
      chatFolders: chatFoldersReducer,
      modals: modalsReducer,
      archive: ArchiveReducer,
      views: ViewsReducer,
      search: SearchReducers
    },
    enhancers: getDefaultEnhancers => {
      return getDefaultEnhancers().concat(sentryReduxEnhancer);
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false
      }).concat(sagaMiddleware as Middleware)
  });
  sagaMiddleware.run(rootSaga);
  return store;
}
